<!-- Тихое текстовое действие внутри компактной строки ПЛАНа/ФАКТа. -->
<template>
  <button
    type="button"
    class="plan-inline-action"
    :class="{ 'plan-inline-action--dotted': dotted }"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "OrderPlanCalculationInlineActionButton",

  inheritAttrs: false,

  props: {
    dotted: { type: Boolean, default: false },
  },

  emits: ["click"],
};
</script>

<style scoped>
.plan-inline-action {
  height: 28px;
  padding: 0 6px;
  border: 0;
  background: transparent;
  color: #5b6070;
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
}

.plan-inline-action:hover,
.plan-inline-action:focus-visible {
  color: #3b5bdb;
  outline: none;
}

.plan-inline-action--dotted {
  text-decoration: underline dotted;
  text-underline-offset: 3px;
}

.plan-inline-action:disabled {
  color: #a3a9b8;
  cursor: default;
}
</style>
